import { render, staticRenderFns } from "./type131.vue?vue&type=template&id=76552bd0&scoped=true"
import script from "./type131.vue?vue&type=script&lang=js"
export * from "./type131.vue?vue&type=script&lang=js"
import style0 from "./type131.vue?vue&type=style&index=0&id=76552bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76552bd0",
  null
  
)

export default component.exports